import type { TaskPage } from "./input/TaskPage"
import type { TaskResult } from "./input/TaskResult"
import type { TaskOptions } from "./TaskOptions"

export type Task = TaskOptions | TaskPage | TaskResult
